import { render, staticRenderFns } from "./Source.vue?vue&type=template&id=80c1cf24&scoped=true"
import script from "./Source.vue?vue&type=script&lang=js"
export * from "./Source.vue?vue&type=script&lang=js"
import style0 from "./Source.vue?vue&type=style&index=0&id=80c1cf24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c1cf24",
  null
  
)

export default component.exports